// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles_icon__12S0a"};